var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"meetings-iframe-container",attrs:{"data-src":_vm.url + '?embed=true'}}),_vm._v(" "),_c('div',{ref:"embedScript"})])}
var staticRenderFns = []

export { render, staticRenderFns }